import { XMarkIcon } from '@heroicons/react/24/outline';
import { Modal } from '@kira/checkpoint-shared-frontend';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import Button, { ButtonVariant } from 'components/Button/Button';
import { t } from 'locales/i18n';

interface ICTAModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  title: string;
  description: string;
  confirmation: string;
  action: () => void;
  isLoading?: boolean;
  primaryButtonText?: string;
  buttonDataTestId?: string;
}

const CTAModal = ({
  isOpen,
  setIsOpen,
  title,
  description,
  confirmation,
  action,
  isLoading,
  primaryButtonText = t('Delete'),
  buttonDataTestId,
}: ICTAModalProps) => {
  const textClass = twMerge('mt-4', 'leading-5', '!prose-body-md-reg');

  const handleCloseModal = () => setIsOpen(false);
  return (
    <Modal
      isOpen={isOpen}
      setOpen={setIsOpen}
      showOverlay
      childContainerClassName="overflow-visible !min-h-full"
    >
      <h3
        className="!prose-title-h3 flex justify-between leading-6 text-kira-slate-900"
        data-testId="deleteConfirmationModal"
      >
        {title}
        <XMarkIcon
          onClick={handleCloseModal}
          className="h-7 w-7 cursor-pointer p-1 hover:rounded-full hover:bg-kira-slate-100"
        />
      </h3>
      <p className={textClass}>{description}</p>
      <p className={textClass}>{confirmation}</p>
      <div className="mt-4 flex justify-end space-x-2">
        <Button
          buttonText={t('Cancel')}
          disabled={isLoading}
          onClick={handleCloseModal}
          type="button"
          variant={ButtonVariant.CANCEL}
          dataTestId="modalCancel"
        />
        <Button
          buttonText={primaryButtonText}
          disabled={isLoading}
          isLoading={isLoading}
          onClick={action}
          type="button"
          variant={ButtonVariant.DELETE}
          dataTestId={buttonDataTestId}
        />
      </div>
    </Modal>
  );
};

export default CTAModal;
